import React, {  useState } from "react";
import { Card, CardBody } from "reactstrap";

import { useNavigate } from "react-router-dom";

import Net_Capital_Pdf from "./Net_Capital_Pdf";
import Net_FnO_Pdf from "./Net_FnO_Pdf";
import Portfolio_Equity_Pdf from "./Portfolio_Equity_Pdf";
import Portfolio_FnO_Pdf from "./Portfolio_FnO_Pdf";
import Financial_Ledger_Pdf from "./Financial_Ledger_withMTF_Pdf";
import Transaction_Ledger_Pdf from "./Transaction_Ledger_Pdf";
import LongnShort_Ledger_Pdf from "./LongnShort_Ledger_Pdf";
import Financial_Ledger_withMTF_Pdf from "./Financial_Ledger_withMTF_Pdf";
import Financial_Ledger_withOutMTF_Pdf from "./Financial_Ledger_withOutMTF_Pdf";
import Financial_Ledger_MTFonly_Pdf from "./Financial_Ledger_MTFonly_Pdf";

const Last_Month_Reports = () => {
  const navigate = useNavigate();
  

  const getPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1); // Get previous month
    return date.toLocaleString("en-US", { month: "long" }).toUpperCase(); // Convert to uppercase
  };
 

  return (
    <>
      <Card className="card-height-100">
        <CardBody className="pt-3">
          <div className="">
            <div
              className="d-flex align-items-center justify-content-between border-bottom"
              style={{
                paddingBottom: "0.9rem",
              }}
            >
              <h4 className="text-dark mb-0">
                Quick Access to your Last Month Reports
              </h4>
            </div>
            <div
              className="d-flex flex-column custom-scrollbar_product_wise_strength"
              style={{
                maxHeight: "345px",
                overflow: "auto",
              }}
            >
              <Financial_Ledger_withMTF_Pdf />
              <Financial_Ledger_withOutMTF_Pdf />
              <Financial_Ledger_MTFonly_Pdf />
              <Transaction_Ledger_Pdf />
              <LongnShort_Ledger_Pdf />
             {/* <Portfolio_Equity_Pdf />
             <Portfolio_FnO_Pdf /> */}
              {/* net position capital report start */}
              {/* <Net_Capital_Pdf /> */}
              {/* net position capital report start */}
              {/* <Net_FnO_Pdf /> */}
            </div>
          </div>
        </CardBody>
      </Card>
     
    </>
  );
};

export default Last_Month_Reports;
